import rocketAnimation from "@client/animations/rocket.json";
import {Lottie} from "@client/hacks";
import * as hardware from "@client/hardware";
import {AnimatePresence, motion} from "motion/react";
import * as React from "react";

// One-time banner: rocket, a title, a short body, one button that dismisses.
export const TourCard = (props: {
    title: React.ReactNode;
    children: React.ReactNode;
    label?: string;
    onDismiss: () => void;
}) => {
    const [isVisible, setIsVisible] = React.useState(true);

    return (
        <AnimatePresence initial={false}>
            {isVisible && (
                // The exit closes the card's height, not just its picture: a
                // scaled card keeps its box and the content below jumps when it
                // goes.
                <motion.div
                    exit={{opacity: 0, height: 0}}
                    transition={{duration: 0.2, ease: "easeOut"}}
                    className="overflow-hidden rounded-xl bg-indigo-50"
                >
                    <div className="flex items-center px-2 py-2.5">
                        <div className="flex size-16 items-center justify-center fill-indigo-100 text-indigo-600">
                            <Lottie
                                animationData={rocketAnimation}
                                loop={true}
                                className="current-color-lottie"
                            />
                        </div>
                        <div className="-ml-4 flex-1 text-center">
                            <h3 className="text-base font-normal text-indigo-900">
                                {props.title}
                            </h3>
                            <p className="text-base text-indigo-500">
                                {props.children}
                            </p>
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                void hardware.haptic();
                                setIsVisible(false);
                                setTimeout(() => {
                                    props.onDismiss();
                                }, 200);
                            }}
                            className="rounded-full bg-indigo-100 px-4 py-2 text-sm font-medium text-indigo-600"
                        >
                            {props.label ?? "Got it"}
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
